import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Avatar, Progress, Dropdown, DownOutlined, CaretDownOutlined, Select } from './AntComponent';
import ReactApexChart from 'react-apexcharts';
import '../assets/styles/dashboard.scss';
import { VectorMap } from "@react-jvectormap/core";
import { worldMill } from "@react-jvectormap/world";
import HamsaLogo from '../assets/images/hamsalogo.svg';

export default function Dashboard() {
  const { Meta } = Card;
  const progressSeriesData = [75.55];
  const items = [
    { label: "KoHamsa", value: "KoHamsa" },
    { label: "KoGaruda", value: "KoGaruda" }
  ];
 
  const regStyle = {
    selected: {
      fill: "#4b93ff"
    },
    initial: {
      fill: "#bfe3e4"
    }
  };

  const seriesData = [
    {
      name: 'series1',
      data: [40, 45, 28, 110, 75, 95, 70, 45, 80],
      type: 'line'
    },
    {
      name: 'series2',
      data: [61, 75, 55, 72, 34, 68, 80, 75, 90],
      type: 'area'
    }
  ];

  const options = {
    chart: {
      height: 350,
      type: 'line',
      toolbar: {
        show: false,
      },

    },
    grid: {
      show: true,
      borderColor: '#d5d5d5',
      strokeDashArray: 3,
      xaxis: {
        lines: {
          show: true
        }
      },
      yaxis: {
        lines: {
          show: false
        }
      }
    },


    title: {
      text: "Project by Status",
      align: 'left',
      floating: false,
      offsetX: 10,
      offsetY: 5,
      style: {
        fontWeight: 'bold',
        FontFamily: 'Lato',
        fontSize: "16px",
      }
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      show: true,
      width: 3
    },
    colors: ['#f7a187', '#b7a9ff'],
    xaxis: {
      type: 'category',
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"],
      axisBorder: {
        show: false
      },
    },
    yaxis: {
      labels: {
        formatter: function (value) {
          return value + "%";
        }
      }
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy HH:mm'
      }
    },
    legend: {
      show: false
    }
  };
  const progressOptions = {
    title: {
      text: "Target",
      align: 'left',
      floating: false,
      offsetX: 10,
      offsetY: 5,
      style: {
        fontWeight: 'bold',
        FontFamily: 'Lato',
        fontSize: "16px",
      }
    },
    subtitle: {
      text: "Revenue Target",
      offsetX: 12,
      offsetY: 30,
      style: {
        fontWeight: 'normal',
        fontFamily: 'Arial',
        color: '#888',
      }
    },
    chart: {
      type: 'radialBar',
      width:'100%',
      offsetY: -0,
      sparkline: {
        enabled: true
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -90,
        endAngle: 90,
        track: {
          background: "#e7e7e7",
          strokeWidth: '15%',
          margin: 5,
          radius:20,
          dropShadow: {
            enabled: false,
            top: 2,
            left: 0,
            color: '#999',
            opacity: 1,
            blur: 2
          }
        },
        dataLabels: {
          name: {
            show: false
          },
          value: {
            offsetY: -2,
            fontSize: '22px',
            strokeWidth: 13,
          }
        }
      }
    },
    grid: {
      padding: {
        top: -10
      }
    },
    stroke: {
      lineCap: 'round', // Use round line caps for semi-gauge effect
    },
    fill: {
      type: 'solid',
      colors:['#0171CE'],
      gradient: {
        shade: 'dark',
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 50, 53, 91]
      },
    },
    labels: ['Average Results'],
  };
  const projMovSeries = [
    {

      data: [20, 18, 19, 24, 26, 14, 20, 22, 18, 24, 20, 21]
    },
    {

      data: [12, 11, 22, 30, 20, 25, 18, 13, 15, 17, 30, 32]
    }
  ];
  const projMovOptions = {
    chart: {
      type: 'line',
      dropShadow: {
        enabled: false,
      },
      toolbar: {
        show: false,
      }
    },
    colors: ['#883dcf', '#f86624'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
      width: 2
    },

    grid: {
      borderColor: '#e7e7e7',
      borderStyle: 'dotted',
      row: {
        colors: ['transparent', 'transparent'],
        opacity: 0.5
      },
    },
    markers: {
      show: false
    },
    xaxis: {
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      title: {
        text: ''
      },
      lines: {
        show: true,
        style: 'dotted'
      }
    },
    yaxis: {
      title: {
        text: ''
      },
      min: 5,
      max: 40
    },
    legend: {
      show: false,
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5
    }
  };
  const healthSeries = [50, 30, 20];
  const healthOptions = {
    colors: ['#3C21F7', '#297EFD', '#219DF7'],
    title: {
      text: "Site Health",
      align: 'left',
      floating: false,
      offsetX: 10,
      offsetY: 5,
      style: {
        fontWeight: 'bold',
        FontFamily: 'Inter-Medium',
        fontSize: "16px",
      }
    },
    subtitle: {
      text: "Revenue check your site health score",
      offsetX: 10,
      offsetY: 25,
      style: {
        fontWeight: 'normal',
        fontFamily: 'Arial',
        color: '#888',
      }
    },
    chart: {
      type: 'donut',
      width: '80%'
    },

    plotOptions: {
      pie: {
        startAngle: -120,
        endAngle: 120,
        offsetX: 30,
        offsetY: -15,
      },
    },
    dataLabels: {
      enabled: false
    },
    legend: {
      position: 'left',
      verticalAlign: 'middle', offsetY: 40,
      offsetX: 5,tainerMargin: {
        left: 0,
        right: 0
      },
      markers: {
        width: 11,
        height: 11,
        radius: 0,
        offsetX: -5
      }
    },
    grid: {
      padding: {
        bottom: -80
      }
    },
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: 250
        },
        legend: {
          position: 'bottom'
        }
      }
    }],

  };
  const healthBarSeries = [
    {
      name: 'PRODUCT A',
      data: [44, 55, 41, 63, 22, 43],
    },
    {
      name: 'PRODUCT B',
      data: [13, 23, 20, 8, 13, 27],
    }
  ];

  const healthBarOptions = {
    chart: {
      type: 'scatter',
      height: 350,
      stacked: false,
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: true,
      },
    },
    grid: {
      show: true,
      borderColor: '#d3d3d3',
      strokeDashArray: 3,   // you can either change hear to disable all grids
      xaxis: {
        lines: {
          show: false  //or just here to disable only x axis grids
        }
      },
      yaxis: {
        lines: {
          show: true  //or just here to disable only y axis
        }
      },
    },
    responsive: [
      {
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0,
          },
        },
      },
    ],

    colors: ['#9dd0f5', '#70a8fe'],
    xaxis: {
      type: 'category',
      categories: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    },
    yaxis: {
      tickAmount: 3,
      axisBorder: {
        show: true,
      },
    },
    legend: {
      show: false,
      position: 'right',
      offsetY: 40,
    },
    fill: {
      opacity: 1,
    },
  };

  return (
    <div className='dashboard'>
      <div className="site-card-wrapper">
        <Row gutter={16}>
          <Col span={6}>
            <Card bordered={false} className="top-card yellow-card text-bold p-2" >
              <div className='card-header'>
                <p className='mb-1 total-count ms-2'>Total Project</p>
              </div>
              <div className='row m-0 pe-4'>
                <h4 className='col-auto ms-auto text-primary fw-bold text-end mb-0'>88</h4>
              </div>
            </Card>
          </Col>
          <Col span={6}>
            <Card bordered={false} className="top-card green-card text-white text-bold p-2">
              <div className='card-header'>
                <p className='mb-1 total-count ms-2'>Total Expense</p>
              </div>
              <div className="row pe-4">
                <h4 className='col-auto ms-auto text-primary fw-bold text-end mb-0'>$558.8k</h4>
              </div>
            </Card>
          </Col>
          <Col span={6} >
            <Card bordered={false} className="top-card blue-card text-white text-bold p-2">
              <div className='card-header'>
                <p className='mb-1 total-count ms-2'>Total Budget</p>
              </div>
              <div className="row pe-4">
                <h4 className='col-auto ms-auto text-primary fw-bold text-end mb-0'>$1500k</h4>
              </div>
            </Card>
          </Col>
          <Col span={6} >
            <Card bordered={false} className="top-card lightblue-card text-white text-bold p-2">
              <div className='card-header'>
                <p className='mb-1 total-count ms-2'>Budget Utilization</p>
              </div>
              <div className="row pe-4">
                <h4 className='col-auto ms-auto text-primary fw-bold text-end mb-0'>66.5%</h4>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="center-card-wrapper mt-3">
        <Row gutter={16} >
          <Col span={7} >
            <Card bordered={false} className="center-card text-white text-bold chart pe-2 ps-0" >
              <ReactApexChart options={healthOptions} series={healthSeries} type="donut" height={250} />
              <ReactApexChart options={healthBarOptions} series={healthBarSeries} type="scatter" height={140} />
            </Card>
          </Col>
          <Col span={11}>
            <Card bordered={false} className="center-card text-white text-bold p-2 chart">
              <ReactApexChart options={options} series={seriesData} type="area" height={350} />
            </Card>
          </Col>
          <Col span={6} >
            <Card bordered={false} className="center-card p-2">
              <div className="row">
                <h6 className='ps-4 py-2 me-1'>Project & Members</h6>
                <div className='col-12 d-flex justify-content-between'>
                  <Card className='mt-2 p-1 border-0 ps-1 w-100'>
                    <div className='row m-0'>
                      <Avatar src={HamsaLogo} className='col-auto' />
                      <div className='col-auto'>
                        <p className='mb-0 prj-name'>KoHamsa</p>
                        <span className='prj-mem'>12 Members</span>
                      </div>
                      <div className='col d-flex'>
                        <Progress percent={80} className='w-50 mt-1 p-0' strokeColor="#22CAAD" size="small" />
                        <span className='prj-name'>Completed</span>
                      </div>

                    </div>
                  </Card>
                </div>
                <div className='col-12 d-flex justify-content-between'>
                  <Card className='mt-2 p-1 border-0 ps-1 w-100'>
                    <div className='row m-0'>
                      <Avatar src={HamsaLogo} className='col-auto' />
                      <div className='col-auto'>
                        <p className='mb-0 prj-name'>KoHamsa</p>
                        <span className='prj-mem'>12 Members</span>
                      </div>
                      <div className='col d-flex'>
                        <Progress percent={60} className='w-50 mt-1 p-0' strokeColor="#F86624" size="small" />
                        <span className='prj-name'>Completed</span>
                      </div>

                    </div>
                  </Card>
                </div>
                <div className='col-12 d-flex justify-content-between'>
                  <Card className='mt-2 p-1 border-0 ps-1 w-100'>
                    <div className='row m-0'>
                      <Avatar src={HamsaLogo} className='col-auto' />
                      <div className='col-auto'>
                        <p className='mb-0 prj-name'>KoHamsa</p>
                        <span className='prj-mem'>12 Members</span>
                      </div>
                      <div className='col d-flex'>
                        <Progress percent={80} className='w-50 mt-1 p-0' strokeColor="#F9C80E" size="small" />
                        <span className='prj-name'>Completed</span>
                      </div>

                    </div>
                  </Card>
                </div>
                <div className='col-12 d-flex justify-content-between'>
                  <Card className='mt-2 p-1 border-0 ps-1 w-100'>
                    <div className='row m-0'>
                      <Avatar src={HamsaLogo} className='col-auto' />
                      <div className='col-auto'>
                        <p className='mb-0 prj-name'>KoHamsa</p>
                        <span className='prj-mem'>12 Members</span>
                      </div>
                      <div className='col d-flex'>
                        <Progress percent={70} className='w-50 mt-1 p-0' strokeColor="#883DCF" size="small" />
                        <span className='prj-name'>Completed</span>
                      </div>

                    </div>
                  </Card>
                </div>
                <div className='col-12 d-flex justify-content-between'>
                  <Card className='mt-2 p-1 border-0 ps-1 w-100'>
                    <div className='row m-0'>
                      <Avatar src={HamsaLogo} className='col-auto' />
                      <div className='col-auto'>
                        <p className='mb-0 prj-name'>KoHamsa</p>
                        <span className='prj-mem'>12 Members</span>
                      </div>
                      <div className='col d-flex'>
                        <Progress percent={20} className='w-50 mt-1 p-0' strokeColor='#EB3D4D' size="small" />
                        <span className='prj-name'>Completed</span>
                      </div>

                    </div>
                  </Card>
                </div>
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <div className="bottom-card-wrapper mt-2">
        <Row gutter={16} >
          <Col span={10} >
            <Card bordered={false} className=" center-card position-relative text-white text-bold p-2"  >
              <div className='row m-0 pt-2'>
                <h6 className='col text-dark my-auto'>Project Moving</h6>
                <Select options={items} className='ms-auto col-md-auto pe-2' defaultValue="KoHamsa"/>
              </div>
              <ReactApexChart options={projMovOptions} series={projMovSeries} type="line" height={250} />
            </Card>
          </Col>
          <Col span={7}>
            <Card bordered={false} className="apex-chart  center-card  text-bold p-2">

              <ReactApexChart options={progressOptions} series={progressSeriesData} type="radialBar" height={380} />
              <p className='m-0 text-center pt-2'>You succeed earn<span className="fw-bolder"> $240</span> April, its higher than past March</p>
              <div className='d-flex progress-detail p-3 pt-2 justify-content-between'>
                <div>
                  <p className='m-0'> Target</p>
                  <h6>$20k<span className="down-arrow"> &darr;</span></h6>
                </div>
                <div>
                  <p className='m-0'> Revenue</p>
                  <h6>$16k<span className="up-arrow"> &uarr;</span></h6>
                </div>
                <div>
                  <p className='m-0'> Today</p>
                  <h6>$1.5k<span className="up-arrow"> &uarr;</span></h6>
                </div>

              </div>
            </Card>
          </Col>
          <Col span={7} >
            <Card bordered={false} className="center-card  text-bold p-2 h-100 map-container">
              <div className="row x ">
                <h6 className='ps-4 me-1 mb-0'>Project by Location</h6>
                <VectorMap map={worldMill} backgroundColor="#ffffff" regionStyle={regStyle} selectedRegions={["US", "IN", "AU", "BR", "CN", "JP", "SA"]} className="vmap-one" />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}